import cn from 'classnames';
import {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {useFormikContext} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import AdvertismentMap from '../../../../../../components/advertisementMap';
import FormikLikeInput from '../../../../../../components/formikFileds/likeInput';
import FormikTextArea from '../../../../../../components/formikFileds/textArea';
import CustomCheckbox from '../../../../../../components/mazraeKit/customCheckbox';
import {useAuth} from '../../../../../../context/authContext';
import {RootState} from '../../../../../../store/redux';
import {
  addFormData,
  addRegisterAdvertisement,
  isSendingData,
} from '../../../../../../store/redux/advertisementRegisteration';
import Num2persian from '../../../../../../utilities/helper/convertNumToPersian';
import {ScrollSection} from '../../../../../../utilities/helper/scrollToError/errorScroll.constants';
import {getPriceUnits} from '../../../../../../utilities/helper/unitGenerator';
import {AdvertisementType} from '../../../../../../utilities/helper/unitGenerator/unit.types';
import {GroupNameToInputName} from '../../../../advertisementList/utils';
import {FromikType} from '../../../types';
import {serviceHandleDescriptionText} from '../../../utils';
import CommonField from '../../commonField';

const WantedServiceEmployeeForm = ({
  isLoading,
  setModalText,
}: {
  isLoading?: boolean;
  setModalText?: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const {supplierProfile} = useAuth();
  const [touched, setTouched] = useState<boolean>(false);
  const [areaText, setAreaText] = useState<string>('');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myRef = useRef<HTMLDivElement | null>(null);

  const {input, sub_input, input_group, serviceBottomSheetData} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const [location, setLocation] = useState<ILocation>({
    lat: Number(supplierProfile?.latlong?.[0]),
    lng: Number(supplierProfile?.latlong?.[1]),
  });

  const {setFieldValue, values, errors} = useFormikContext<FromikType>();

  useEffect(() => {
    if (
      input &&
      sub_input &&
      input_group &&
      input_group.type &&
      values?.wanted_number &&
      values?.employing_duration
    ) {
      setFieldValue(
        'title',
        serviceHandleDescriptionText(
          values,
          sub_input?.title,
          values?.wanted_number,
          input?.title,
        )[input_group.type],
      );
      setAreaText(
        serviceHandleDescriptionText(
          values,
          sub_input?.title,
          values?.wanted_number,
          input?.title,
        )[input_group.type],
      );
    }
  }, [
    sub_input,
    input_group,
    values?.wanted_number,
    values?.employing_duration,
    values?.employing_duration_unit,
  ]);

  useEffect(() => {
    setFieldValue('location', location);
  }, [location]);

  useEffect(() => {
    myRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [myRef.current]);

  return (
    <div className="flex flex-col gap-2">
      <section className="flex flex-col" id={ScrollSection.SUB_INPUT}>
        <div className="flex mb-2 text-gray-900 font-Medium" ref={myRef}>
          <span className="text-md">
            نوع {input_group?.type && GroupNameToInputName[input_group?.type]}
            {input?.title} را وارد کنید.
          </span>
          <span className="color-red-3">*</span>
        </div>
        <div
          className={cn(
            'w-full h-12 rounded border-[1px] border-gray-700 px-2 flex items-center',
            {
              '!border-red-550': touched && errors.sub_input?.title,
              '!border-farm-shop-500':
                values.sub_input?.title && !errors.sub_input?.title,
            },
          )}
        >
          {!sub_input?.title && (
            <i className="mx-1 text-xl text-gray-700 icon-nameSearch" />
          )}
          <input
            className="w-full text-gray-700 text-md"
            name="sub_input"
            readOnly={true}
            value={sub_input?.title}
            placeholder="انتخاب نوع"
            onClick={() => {
              navigate('/advertisement-register-subInput-list', {
                state: {
                  input: input?.guid,
                  backRoute: '/advertisement-registeration',
                },
              });
            }}
          ></input>
        </div>
        <span className="pt-1 text-xs text-red-550">
          {touched && errors.sub_input?.title}
        </span>
      </section>
      <section id={ScrollSection.INPUT_UNIT}>
        <p className="mb-2 font-medium color-gray-1 text-md ">
          تعداد نیروی کار مورد نیازتان را تعیین کنید.
          <span className=" color-red-3">*</span>
        </p>
        <FormikLikeInput
          name="wanted_number"
          label="تعداد مورد نیاز"
          required={false}
          touched={touched}
          type="number"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFieldValue('wanted_number', e.target.value);
          }}
        />
      </section>
      <section>
        <p className="mb-2 font-medium color-gray-1 text-md ">
          مدت زمان مورد نیازتان را تعیین کنید.
          <span className="color-red-3 ">*</span>
        </p>
        <CommonField
          touched={touched}
          inputName="employing_duration"
          bottomSheetName="employing_duration_unit"
          label="مدت زمان مورد نیاز"
          inputRequired={false}
          commonBottomSheetData={getPriceUnits(
            serviceBottomSheetData as AdvertisementType,
            input_group?.code as number,
            input?.code,
          )}
          disabled={values.price_on_call}
          type="number"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue('employing_duration', e.target.value);
          }}
        />
        {values.employing_duration && (
          <span className="text-xs text-farm-shop-500">
            {Num2persian(values.employing_duration?.toString())}
            {values?.employing_duration_unit?.title}
          </span>
        )}
      </section>

      <section id={ScrollSection.TITLE}>
        <FormikTextArea
          name="title"
          placeholder=""
          description=""
          label="متن درخواست"
          required
          rows={5}
          labelClass="!text-md font-medium"
        />
        <span className="text-xs text-gray-900">
          می توانید متن درخواست خود را ویرایش کنید.
        </span>
      </section>
      <section className="flex flex-col mt-3" id={ScrollSection.LOCATION}>
        <span className="mb-3 text-md">محدوده آگهی</span>
        <div className="z-0 edit-ads-map">
          <AdvertismentMap
            center={location}
            selectLocation={location => {
              setFieldValue('location', location);
              setLocation(location);
            }}
          />
        </div>
      </section>
      <section className="pr-1">
        <CustomCheckbox
          name="only_massage_buyer"
          title="فقط اجازه ارسال پیام به خریدار داده شود."
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setFieldValue('only_massage_buyer', e.target.checked)
          }
          checked={values?.only_massage_buyer}
        />
      </section>
      <button
        className={cn('w-full text-white h-12 rounded mb-3', {
          'bg-farm-shop-200': isLoading,
          'bg-farm-shop-500': !isLoading,
        })}
        type="submit"
        disabled={isLoading}
        onClick={() => {
          dispatch(
            addRegisterAdvertisement({
              is_change_title: areaText === values?.title,
            }),
          );
          setModalText && setModalText('');
          if (areaText === values?.title) {
            setModalText &&
              setModalText('آگهی شما با موفقیت در فروشگاه مزرعه منتشر شد.');
          }

          dispatch(addFormData(JSON.stringify(values)));
          dispatch(isSendingData(true));
          setTouched(true);
        }}
      >
        ثبت آگهی
      </button>
    </div>
  );
};

export default WantedServiceEmployeeForm;
